var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetWhite3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.481 492.481",
    xmlSpace: "preserve",
    style: {
      height: "4.3rem",
      width: "4.3rem"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.6002,
    y1: 621.3422,
    x2: -17.2782,
    y2: 547.7642,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 404.0846 4917.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41, 211, 218)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "rgb(0, 119, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "rgb(6, 64, 147)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(8, 70, 152)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25.687,297.141 135.735,0 271.455,0 161.398,297.141 ",
    style: _defineProperty({
      fill: "url(&quot"
    }, "fill", "white")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.0735,
    y1: 620.7541,
    x2: -11.7045,
    y2: 560.3241,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 404.0846 4917.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    style: {
      stopColor: "rgb(224, 179, 134)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "rgb(218, 73, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(150, 20, 132)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "123.337,394.807 233.409,97.674 369.144,97.674 259.072,394.807 ",
    style: _defineProperty({
      fill: "url(&quot"
    }, "fill", "white")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0324,
    y1: 554.688,
    x2: -10.4176,
    y2: 584.028,
    gradientTransform: "matrix(7.8769 0 0 -7.8769 404.0846 4917.9966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41, 211, 218)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    style: {
      stopColor: "rgb(0, 119, 255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "rgb(6, 64, 147)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(8, 70, 152)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "221.026,492.481 331.083,195.348 466.794,195.348 356.746,492.481 ",
    style: _defineProperty({
      fill: "url(&quot"
    }, "fill", "white")
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetWhite3);
export default __webpack_public_path__ + "static/media/asset-white-3.64436e86.svg";
export { ForwardRef as ReactComponent };